import Hint from "@common/controls/Hint/component";
import withValueHOC from "@common/hocs/withValue";
import MailCheck from "mailcheck";
import React from "react";
import ReactDOM from "react-dom";
import TextInput, { type TextInputProps } from "./component";

export type EmailInputProps = Omit<TextInputProps, "autoComplete" | "type"> & {
  hintRef?: React.RefObject<HTMLElement>;
};
const EmailInputBase = React.forwardRef(({ onBlur, ...props }: EmailInputProps, ref: React.RefObject<any>) => {
  const [suggestion, setSuggestion] = React.useState("");

  const _onBlur = React.useCallback(() => {
    const sug = MailCheck.run({
      email: props.value,
      topLevelDomains: [...MailCheck.defaultTopLevelDomains, "io"]
    });

    setSuggestion(sug ? sug.full : "");
    onBlur && onBlur();
  }, [props.value, setSuggestion]);

  const onSuggestionClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();

      setSuggestion("");
      props.onChange(suggestion);
    },
    [props.onChange, suggestion]
  );

  return (
    <>
      <TextInput ref={ref} {...props} autoComplete="email" type="email" maxLength={256} onBlur={_onBlur} />
      {suggestion &&
        (props.hintRef?.current ? (
          ReactDOM.createPortal(<Suggestion text={suggestion} onClick={onSuggestionClick} />, props.hintRef.current)
        ) : (
          <Suggestion text={suggestion} onClick={onSuggestionClick} />
        ))}
    </>
  );
});
const EmailInput = withValueHOC<string, EmailInputProps>(EmailInputBase);
export default EmailInput;

type SuggestionProps = {
  onClick: (e: React.MouseEvent) => void;
  text: string;
};
const Suggestion = (props: SuggestionProps) => (
  <Hint>
    Did you mean{" "}
    {
      <a className="pointer" onClick={props.onClick}>
        {props.text}
      </a>
    }
    ?
  </Hint>
);
